<template>
  <b-modal
    id="save-license-modal"
    ref="save-license-modal"
    centered
    @show="show"
    @hidden="visible = false"
    @ok="handleOk"
    @cancel="handleCancel"
    body-class="nice-modal"
    :footer-class="firstSaveIntro ? 'justify-content-center' : 'hide-cancel'"
    :visible="visible"
    :ok-title="firstSaveIntro ? $t('license.saving.keep_on_server') : $t('button.close')"
    :cancel-title="$t('license.saving.encrypt')"
    :cancel-variant="firstSaveIntro ? 'primary' : 'secondary'"
    :busy="loading"
    no-close-on-backdrop
    :no-close-on-esc="!firstSaveIntro"
    :cancel-disabled="!firstSaveIntro"
    :title="firstSaveIntro ? $t('license.saving.h') : encryptedUpdateTips ? $t('license.saving.h_enc') : $t('license.saving.h_done')"
  >
    <div>
      <div class="icon-wrapper mb-2">
        <template v-if="firstSaveIntro || completed">
          <div class="encrypted-icon"></div>
          <div
            class="unencrypted-icon"
            :class="{ 'move-left': encrypted }"
          ></div>
        </template>
        <template v-if="encryptedUpdateTips">
          <div class="encrypted-icon"></div>
        </template>
      </div>
      <b-overlay :show="loading" variant="white" opacity="1">
        <div v-if="firstSaveIntro">
          <h4 class="text-center mb-4 mb-sm-5">{{ $t('license.saving.selection.h') }}</h4>
          <h6>{{ $t('license.saving.selection.keep_h') }}</h6>
          <div class="mb-2">{{ $t('license.saving.selection.keep_msg') }}</div>
          <div class="text-secondary mb-3 mb-sm-4">{{ $t('license.saving.selection.keep_note') }}</div>
          <h6>{{ $t('license.saving.selection.enc_h') }}</h6>
          <div class="mb-2">
            {{ $t('license.saving.selection.enc_msg') }} <a :href="URL_SAVE_MODE">{{ $t('license.saving.selection.enc_more') }}</a>
          </div>
          <div class="text-secondary">
            {{ $t('license.saving.selection.enc_note') }}
          </div>
        </div>

        <div v-if="encryptedUpdateTips">
          <h5 class="text-center mb-4">{{ $t('license.saving.enc_download._') }}</h5>
          <div class="mb-3">{{ $t('license.saving.enc_download.notice') }}</div>
          <code class="mb-3">./rdbm -c db.cfg license</code>
          <div class="t90p mb-4">
            <i18n path="license.saving.enc_download.more" tag="label" for="license.saving.enc_download.link">
              <a :href="URL_ENCRYPTED_RE_DOWNLOAD" target="_blank">{{ $t('license.saving.enc_download.link') }}</a>
            </i18n>
          </div>
          <div class="text-secondary">{{ $t('license.saving.enc_download.ps') }}</div>
        </div>

        <div v-if="completed && wrapped && wrapped.data">
          <h4 class="text-center mb-4 mb-sm-5">{{ $t('license.saving.done.h') }}</h4>
          <div v-if="encrypted" class="mb-4 text-center font-weight-bold">{{ $t('license.saving.done.enc_warning') }}</div>
          <div class="mb-3 text-center">
            <div class="mb-3">
              {{ $t('license.saving.done.msg') }}
            </div>
            <div class="mb-4">
              {{ validUntilFormated(wrapped.data) }}
            </div>
            <div>{{ $t('license.saving.done.or_pay') }}</div>
          </div>
          <div class="mb-5 text-center">
            <b-button @click="handlePayClick()">{{ $t('license.saving.done.action') }}</b-button>
          </div>
        </div>

        <template #overlay>
          <div class="text-center">
            <b-spinner class="mb-5"></b-spinner>
            <p v-if="downloading" class="font-weight-bold">{{ $t('license.saving.progress.downloading') }}</p>
            <p v-else class="font-weight-bold">{{ $t('license.saving.progress.creation') }}</p>
          </div>
        </template>
      </b-overlay>
    </div>
  </b-modal>
</template>

<script>
import { validUntilFormatted, toRequestObj } from "@/components/rdbm/license.js";
import { wait } from "@/plugins/request.js";
import { saveAs } from "file-saver";
import { licenseObject } from "@/components/rdbm/license.js";
import {URL_SAVE_MODE_DETAILS, URL_SAVE_ENCRYPTED_LICENSE, URL_ENCRYPTED_RE_DOWNLOAD} from "@/globals"

export default {
  name: "PayLicenseModal",
  components: {},
  props: ["licenseWrapper"],
  data() {
    return {
      wrapped: this.licenseWrapper,
      loading: false,
      visible: false,
      // Первое сохранение, обьяснительная страница
      firstSaveIntro: false,
      // Подготовка к скачиванию
      downloading: false,
      // Для анимации
      encrypted: false,
      completed: false,
      // Подсказка для варианта скачивания зашифрованной лицензии
      encryptedUpdateTips: false,
    };
  },
  methods: {
    validUntilFormated: function (licence) {
      return validUntilFormatted(licence);
    },
    show() {
      this.firstSaveIntro = false;
      this.encryptedUpdateTips = false;
      if (this.wrapped.data.encrypt) {
        this.encryptedUpdateTips = true;
      } else {
        this.firstSaveIntro = true;
      }

      this.downloading = false;
      this.encrypted = false;
      this.completed = false;
      this.visible = true;
    },
    handleOk() {
      if (this.firstSaveIntro) {
        // Отошлем редактору событие чтобы сохранил читаемый набросок
        this.$emit("save-draft");
      }
    },
    handleCancel(bvModalEvt) {
      if (this.firstSaveIntro) {
        // Prevent modal from closing
        bvModalEvt.preventDefault();
        // Запрос на сервер
        this.loading = true;
        this.$post(
          URL_SAVE_ENCRYPTED_LICENSE,
          toRequestObj(this.wrapped.data),
          true,
          false,
          true
        )
          .then((result) => {
            // Анимируем, задержка чуть больше чем animation-duration
            this.encrypted = true;
            this.downloading = true;
            wait(1200).then(() => {
              this.loading = false;
              this.firstSaveIntro = false;

              // Скачка через механизм HTML5
              var byteString = atob(result.image);
              var ab = new ArrayBuffer(byteString.length);
              var ia = new Uint8Array(ab);

              for (var i = 0; i < byteString.length; i++) {
                ia[i] = byteString.charCodeAt(i);
              }

              let blob = new Blob([ab], { type: "text/plain;charset=utf-8" });
              saveAs(blob, "rdbm-" + result.license.id + ".license");

              // Теперь надо заменить обьект лицензии на полученный с сервера,
              // сохраняя еще пока известные зашифрованные имена.
              this.$set(
                this,
                "wrapped",
                licenseObject.init(result.license, true)
              );
              // Отошлем редактору событие чтобы сменил url
              this.$emit("encrypted-saved");

              this.completed = true;
            });
          })
          .catch((error) => {
            this.$alert.show(error);
            this.loading = false;
          });
      }
    },
    handlePayClick() {
      this.$bvModal.hide("save-license-modal");
      this.$emit("pay-license");
    },
  },
  created () {
    this.URL_SAVE_MODE = URL_SAVE_MODE_DETAILS;
    this.URL_ENCRYPTET_RE_DOWNLOAD = URL_ENCRYPTED_RE_DOWNLOAD;
  }
};
</script>

<style scoped>
.icon-wrapper {
  width: 200px;
  height: 98px;
  margin: 0 auto;
  position: relative;
}
.small .icon-wrapper {
  width: 150px;
  height: 74px;
}
.encrypted-icon {
  width: 200px;
  height: 98px;
  background: url("/encrypted-field.svg");
  background-size: 200px 98px;
  background-repeat: no-repeat;
}
.small .encrypted-icon {
  width: 150px;
  height: 74px;
  background-size: 150px 74px;
}
.unencrypted-icon {
  width: 200px;
  height: 98px;
  background: url("/unencrypted-field.svg");
  background-size: 200px 98px;
  background-repeat: no-repeat;
  position: absolute;
  left: 0;
  top: 0;
}
@keyframes moveLeft {
  0% {
    background-position-x: 0px;
  }

  100% {
    background-position-x: -120px;
  }
}
.move-left {
  animation-duration: 1s;
  transition-timing-function: ease-in;
  animation-fill-mode: both;
  animation-name: moveLeft;
}
</style>